import ApiService from '@/core/services/api.service';

const base = () => 'v1/opening-balance-cost';

/** POST gộp một request (`stockMode`: mixed). Tương thích; ưu tiên dùng batch tách luồng. */
export function postOpeningBalanceCostBatch(body) {
  return ApiService.post(`${base()}/batch`, body);
}

/** NK 72 — chỉ ProductStock; `lines` không có imeiId / imeiNo. */
export function postOpeningBalanceCostBatchProductStock(body) {
  return ApiService.post(`${base()}/batch/product-stock`, body);
}

/** NK 73 — chỉ ProductImeiStock; mỗi dòng cần imeiId và/hoặc imeiNo. */
export function postOpeningBalanceCostBatchImeiStock(body) {
  return ApiService.post(`${base()}/batch/imei-stock`, body);
}

/** Validate import IMEI cho màn nhập giá vốn đầu kỳ (không dùng opening-stock-slip). */
export function postOpeningBalanceCostValidateImportImei(body) {
  return ApiService.post(`${base()}/validate-import-imei`, body);
}

/** Preview gộp ProductStock ∪ ProductImeiStock (`stockKind`: mixed). */
export function getOpeningBalanceCostPreview(params) {
  return ApiService.query(`${base()}/preview`, { params });
}

/** Preview chỉ ProductStock (NK 72). */
export function getOpeningBalanceCostPreviewProductStock(params) {
  return ApiService.query(`${base()}/preview/product-stock`, { params });
}

/** Preview chỉ ProductImeiStock (NK 73). */
export function getOpeningBalanceCostPreviewImeiStock(params) {
  return ApiService.query(`${base()}/preview/imei-stock`, { params });
}

/**
 * GET lịch sử chỉnh giá đầu kỳ (optional).
 */
export function getOpeningBalanceCostChanges(params) {
  return ApiService.query(`${base()}/changes`, { params });
}
